module.exports = __webpack_public_path__ + "assets/images/project/constituencies/macpherson-smc.jpg?v=8c4077b6";